export const environment = {
  production: false,
  apiUrl: 'https://carts-api.dev2.scrij.com/api/v1',
  apiV2Url: 'https://carts-api.dev2.scrij.com/api/v2',
};
